import styles from './index.module.css'

import { TbSparkles } from '@react-icons/all-files/tb/TbSparkles'
import React from 'react'

import { Button, Switch, Text } from 'components/ds'

type Props = {
  active?: boolean
  onActivate: () => void
  onDeactivate: () => void
}

const AiSearchToggle = ({
  active = false,
  onActivate,
  onDeactivate,
}: Props): React.ReactNode => {
  const handleToggle = () => {
    if (active) onDeactivate()
    else onActivate()
  }

  return (
    // Rendered as a span: the Radix Switch is itself a <button>, and buttons can't be nested
    <Button
      asChild
      variant="ghost"
      className={`${styles.btn} ${active ? styles.btnActive : ''}`}
      aria-pressed={active}
      aria-label="AI Search"
      onMouseDown={e => {
        e.preventDefault()
        handleToggle()
      }}
      // A span doesn't turn Enter/Space into a click like a native button does
      onKeyDown={e => {
        if (e.key !== 'Enter' && e.key !== ' ') return
        e.preventDefault()
        handleToggle()
      }}
      onClick={e => {
        if (e.detail === 0) handleToggle()
      }}
    >
      <span role="button" tabIndex={0}>
        <TbSparkles size={11} />
        <Text as="span" className={styles.label}>
          AI Search
        </Text>
        <Switch
          size="1"
          checked={active}
          className={styles.switch}
          tabIndex={-1}
          aria-hidden
        />
      </span>
    </Button>
  )
}

export default AiSearchToggle
